import type React from 'react';

interface LogoColorIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function LogoColorIcon({ size = 24, ...props }: LogoColorIconProps) {
  return (
    <svg
      id="Native Teams stroke"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9714 7.12974C13.9214 7.12974 15.5021 5.53369 15.5021 3.56487C15.5021 1.59605 13.9214 0 11.9714 0C10.0214 0 8.44067 1.59605 8.44067 3.56487C8.44067 5.53369 10.0214 7.12974 11.9714 7.12974Z"
        fill="#FF2C55"
      />
      <path
        d="M15.3058 13.5389L2.29351 0.400688C1.44736 -0.453644 0 0.151976 0 1.359V14.4143C0 15.0986 0.549718 15.6522 1.22608 15.6522H2.96013C3.63788 15.6522 4.18621 15.0972 4.18621 14.4143V11.4255L8.01336 15.2897C8.24299 15.5215 8.55472 15.6522 8.88038 15.6522H14.4374C15.5299 15.6522 16.0768 14.3187 15.3044 13.5389H15.3058Z"
        fill="#FF2C55"
      />
    </svg>
  );
}
